<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <!-- <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button> -->
          <!-- <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button> -->
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listBaoyueBtn">包月</el-button>
          <!-- <el-button class="ik-list-menu-btn" size="medium" @click="listDeleteBtn">删除</el-button> -->
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <!-- <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button> -->
          <!-- <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button> -->
          <!-- <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button> -->
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <!-- <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button> -->
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_name'"
                v-model="data.head['name']"
                code="name"
                name="名称"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_robotTypeCode'"
                v-model="data.head['robotTypeCode']"
                url="base/user/robot/robottype/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="robotTypeCode"
                name="机器人类型编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_robotTypeName'"
                v-model="data.head['robotTypeName']"
                code="robotTypeName"
                name="机器人类型名称"
                default-value=""
                :edit="false"
                disabled
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_robotCode'"
                v-model="data.head['robotCode']"
                code="robotCode"
                name="设备号"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_cityInfoCode'"
                v-model="data.head['cityInfoCode']"
                url="base/sys/apply/cityinfo/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="cityInfoCode"
                name="城市编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_cityInfoName'"
                v-model="data.head['cityInfoName']"
                code="cityInfoName"
                name="城市名称"
                default-value=""
                :edit="false"
                disabled
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_monthlyFlag'"
                v-model="data.head['monthlyFlag']"
                code="monthlyFlag"
                name="包月标识"
                default-value="0"
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.monthlyFlag)"
                :disabled="false"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_monthlyEndTime'"
                v-model="data.head['monthlyEndTime']"
                code="monthlyEndTime"
                name="包月结束时间"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <!-- 标题栏 -->
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <!-- 查询菜单 -->
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_name'"
                      v-model="searcher['name']"
                      code="name"
                      name="名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_robotTypeCode'"
                      v-model="searcher['robotTypeCode']"
                      code="robotTypeCode"
                      name="机器人类型编码"
                      url="base/user/robot/robottype/find/findPagination"
                      :filed-list="[
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="name"
                      :searcher="{}"
                      default-value=""
                      :disabled="false"
                      @onFieldChange="onFieldChange"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_robotTypeName'"
                      v-model="searcher['robotTypeName']"
                      code="robotTypeName"
                      name="机器人类型名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_robotCode'"
                      v-model="searcher['robotCode']"
                      code="robotCode"
                      name="设备号"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <!-- 操作按钮 -->
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-text
            code="code"
            name="编码"
            :edit="false"
          />
          <ik-column-text
            code="name"
            name="名称"
            :edit="false"
          />
          <ik-column-text
            code="robotTypeCode"
            name="机器人类型编码"
            :edit="false"
          />
          <ik-column-text
            code="robotTypeName"
            name="机器人类型名称"
            :edit="false"
          />
          <ik-column-text
            code="robotCode"
            name="设备号"
            :edit="false"
          />
          <ik-column-text
            code="cityInfoCode"
            name="城市编码"
            :edit="false"
          />
          <ik-column-text
            code="cityInfoName"
            name="城市名称"
            :edit="false"
          />
          <ik-column-select
            code="monthlyFlag"
            name="包月标识"
            :edit="false"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.monthlyFlag)"
          />
          <ik-column-text
            code="monthlyEndTime"
            name="包月结束时间"
            :edit="false"
          />
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>

    <!--  包月支付弹窗 start  -->
    <el-dialog width="479px" :visible.sync="payVisible" title="支付结算" :close-on-click-modal="false">
      <div class="robot-pay-content">
        <!-- 机器信息 -->
        <div class="label-con flex flex-row align-center">
          <div class="icon" />
          <div class="label">机器名称</div>
        </div>
        <div class="pay-info-value">{{ activeRow.name }}</div>

        <!-- 支付方式 -->
        <div class="label-con flex flex-row align-center">
          <div class="icon" />
          <div class="label">支付方式</div>
        </div>
        <div class="pay-con flex flex-row justify-between">
          <div
            class="icon cursor-pointer flex flex-col align-center"
            @click="handlePay('aliPay')"
          >
            <img class="icon-img" src="@/assets/list/aliPay.png" alt="">
            <span class="label">支付宝</span>
          </div>
          <div
            class="icon cursor-pointer flex flex-col align-center"
            @click="handlePay('wechat')"
          >
            <img class="icon-img" src="@/assets/list/wechat.png" alt="">
            <span class="label">微信</span>
          </div>
          <!-- <div
            class="icon cursor-pointer flex flex-col align-center"
            @click="handlePay('offline')"
          >
            <img class="icon-img" src="@/assets/list/offline.png" alt="">
            <span class="label">线下</span>
          </div> -->
        </div>
      </div>
    </el-dialog>
    <!--  包月支付弹窗 end  -->

    <!--  二维码 start  -->
    <el-dialog
      width="479px"
      :destroy-on-close="true"
      :show-close="false"
      :modal="false"
      custom-class="qrcode-con"
      :visible.sync="qrcodeVisible"
      @closed="clearQrcode"
    >
      <div class="flex flex-col align-center">
        <div class="flex flex-row align-center pay-header">
          <img
            v-if="payWay==='aliPay'"
            src="@/assets/list/aliPay.png"
            alt=""
            class="icon-img"
          >
          <img
            v-if="payWay==='wechat'"
            src="@/assets/list/wechat.png"
            alt=""
            class="icon-img"
          >
          <span class="tip">请使用{{ payWay|PAY_WAY }}扫码支付</span>
        </div>
        <div ref="qrcode" />
      </div>
    </el-dialog>
    <!--  二维码 end  -->
  </el-container>
</template>

<script>
// 表单组件
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkPagination from '@/components/ik/pagination/IkPagination'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import store from '@/store'
import QRCode from 'qrcodejs2'

import { getById, findPage, save, update, remove, postData } from '@/api/ik/data/dataApi'
export default {
  components: {
    // 表单组件
    IkFormText,
    IkFormDataPopup,
    IkFormSelect,
    IkColumnText,
    IkPagination,
    IkColumnSelect
  },
  filters: {
    /**
     * 支付方式
     * @param payWay
     * @returns {string}
     * @constructor
     */
    PAY_WAY(payWay) {
      switch (payWay) {
        case 'wechat':
          return '微信'
        case 'aliPay':
          return '支付宝'
      }
    }
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'base/user/robot/robot',
      // Web路径
      webPath: 'clinic/robot',
      // 标识字段JSON
      jsonStr: {
        monthlyFlag: '[{"key": "0", "value": "未包月"}, {"key": "1", "value": "已包月"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: '0',
      searcher: {
        storeCode: '',
        robotTypeCode: ''
      },
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: {},
        body: {}
      },
      // 子表清单
      bodyMap: [],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: '',
      verify: {
        head: {},
        body: {}
      },
      // ===== ===== ===== ===== 支付相关属性 ===== ===== ===== =====
      payVisible: false,
      qrcodeVisible: false,
      payWay: 'aliPay'
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || 'list'
    this.mode = this.$route.params.mode || 'list'
    this.id = this.$route.query.id || 0
    // 初始化界面，设置模式取值
    if (this.mode === 'list') {
      this.viewMode = 'list'
    } else {
      this.viewMode = 'info'
    }
    // 列表页进入时的处理
    if (this.viewMode === 'list') {
      this.find()
    } else if (this.viewMode === 'info') {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要查看的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页包月按钮点击
    listBaoyueBtn() {
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要包月的行!'
        })
      } else {
        $this.payVisible = true
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = 'edit'
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = 'edit'
    },
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = 'details'
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      // 修改为详情模式
      this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 支付相关方法 ===== ===== ===== =====
    /**
     * 处理支付方式选择
     */
    handlePay(way) {
      const payTypeMap = { aliPay: '1', wechat: '2', offline: '3' }
      this.payWay = way
      const p = {
        rbCode: this.activeRow.code,
        payTypeSign: payTypeMap[way]
      }
      postData('clinic/settlement/clinicstlmt/monthlystlmt/do/createmonthlystlmt', p).then(res => {
        if (way === 'offline') {
          this.$message.success('线下支付成功')
          this.payVisible = false
          this.find()
        } else {
          if (res.data && res.data.link) {
            this.showQrCode(res.data.link)
          } else {
            this.$message.error('获取支付链接失败')
          }
        }
      }).catch(err => {
        console.error('包月支付接口调用失败:', err)
        this.$message.error('支付请求失败')
      })
    },
    /**
     * 显示二维码
     * @param url
     */
    showQrCode(url) {
      this.payVisible = false
      this.qrcodeVisible = true
      this.$nextTick(() => {
        if (this.$refs.qrcode) {
          this.$refs.qrcode.innerHTML = ''
        }
        new QRCode(this.$refs.qrcode, {
          text: url,
          width: 274,
          height: 274,
          colorDark: '#000000',
          colorLight: '#ffffff'
        })
      })
    },
    /**
     * 清空二维码
     */
    clearQrcode() {
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = ''
      }
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
    },
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)

      if ((fieldName === 'robotTypeCode' || fieldName === 'cityInfoCode') && (!newValue || newValue === '')) {
        const nameField = fieldName.replace('Code', 'Name')
        this.$set(this.data.head, nameField, '')
        // 修复 ESLint no-prototype-builtins
        if (Object.prototype.hasOwnProperty.call(this.searcher, nameField)) {
          this.$set(this.searcher, nameField, '')
        }
      }
    },
    onFieldChange2(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是机器人类型点击
      if (code === 'robotTypeCode') {
        this.searcher['robotTypeCode'] = row.code
        this.searcher['robotTypeName'] = row.name
      } else if (code === 'cityInfoCode') {
        this.searcher['cityInfoCode'] = row.code
        this.searcher['cityInfoName'] = row.name
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是机器人类型点击
      if (code === 'robotTypeCode') {
        this.data.head['robotTypeId'] = row.id
        this.data.head[code] = row.code
        this.data.head['robotTypeName'] = row.name
        this.data.head['robotModelCode'] = row.robotModelCode
      } else if (code === 'cityInfoCode') {
        this.data.head['cityInfoId'] = row.id
        this.data.head[code] = row.code
        this.data.head['cityInfoName'] = row.name
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = 'info'
          $this.mode = 'details'
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = 'info'
          $this.mode = 'details'
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      this.searcher.storeCode = this.storeCode
      // 获取树组件数据
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    // 启用词典
    listOpenBtn() {
      const $this = this
      postData(this.bgPath + '/do/enabledic', { 'storeCode': $this.storeCode, 'dictionaryCode': this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已启用!'
        })
      })
    },
    // 停用词典
    listCloseBtn() {
      const $this = this
      postData(this.bgPath + '/do/disabledic', { 'storeCode': $this.storeCode, 'dictionaryCode': this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已禁用!'
        })
      })
    },
    // 同步词典
    listSyncBtn() {
      const $this = this
      $this.listLoading = true
      postData(this.bgPath + '/do/syncdic', { 'storeCode': $this.storeCode }).then(res => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已同步!'
        }).catch(() => {
          $this.listLoading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/listinfo.scss";
.data-directory-tabs-info{height:calc(100% - 60px);}
.data-directory-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}

/* 包月支付弹窗内容 - 按照 Enroll / Pay.vue 样式重构 */
.robot-pay-content {
  padding: 10px 0 20px;

  .label-con {
    margin-bottom: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .icon {
      width: 4px;
      height: 14px;
      background: #165DFF;
      border-radius: 0;
      margin-right: 8px;
    }

    .label {
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: bold;
      font-size: 16px;
      color: #1D2129;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  .pay-info-value {
    padding: 0 12px;
    margin-bottom: 24px;
    font-size: 18px;
    color: #303133;
    font-weight: bold;
  }

  .pay-con {
    padding: 49px 40px 45px 41px;
    background-color: rgb(222, 237, 251);
    display: flex;
    flex-direction: row;
    justify-content: center;   /* ← 改为居中 */

    .icon {
      background: #fff;
      padding: 8px 14px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      margin: 0 24px;            /* ← 两个图标之间留出均匀间距 */

      .icon-img {
        width: 60px;
        height: 60px;
        margin-bottom: 3px;
      }

      .label {
        font-family: 思源黑体 CN, serif;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
      }
    }
  }
}

/* 二维码弹窗样式 - 与 Enroll.vue 保持一致 */
.pay-header {
  margin-bottom: 73px;
  .icon-img {
    width: 60px;
    height: 60px;
    margin-right: 16px;
  }
  .tip {
    font-family: 思源黑体 CN PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 24px;
    line-height: 22px;
  }
}
::v-deep .qrcode-con {
  background-image: url("../../../../assets/list/qrcode.png");
  background-repeat: no-repeat;
  height: 676px;
  border-radius: 30px 30px 0 0;
  padding-top: 105px;
}
.querybg {
  overflow: visible;
}
.querybg ::v-deep .el-collapse-item__wrap {
  overflow: visible !important;
}
</style>
